import type { Router } from '@angular/router';

/**
 * Opens a workbook in the editor: AM-78's route, `/sheets/open?id=…`, with `&sheet=…` to land on one sheet
 * (AM-109's sheet buttons). On the unguarded `/sheets-spike` page, that page's own `open`.
 *
 * One place for the route, because three controls lead there: "Edit workbook" and the preview's sheet
 * buttons in the detail view, and "Open" in the workbook's "…" menu, on a card or in the detail header,
 * which opens the editor as the prototype's does (gap row 39).
 */
export function openWorkbookInEditor(router: Pick<Router, 'navigate' | 'url'>, id: string, sheetId?: string): Promise<boolean> {
  const base = router.url.startsWith('/sheets-spike') ? '/sheets-spike' : '/sheets';
  return router.navigate([`${base}/open`], { queryParams: sheetId ? { id, sheet: sheetId } : { id } });
}
